import { render, staticRenderFns } from "./ClinicianSidebar.vue?vue&type=template&id=3ce9197c"
import script from "./ClinicianSidebar.vue?vue&type=script&lang=js"
export * from "./ClinicianSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports